module.exports = __webpack_public_path__ + "static/portfolio_gallery_6-10eb76ef8425291d468c16b3bfd41e06.jpg";